import { render, staticRenderFns } from "./mob.vue?vue&type=template&id=51057786&scoped=true"
import script from "./mob.vue?vue&type=script&lang=ts"
export * from "./mob.vue?vue&type=script&lang=ts"
import style0 from "./mob.vue?vue&type=style&index=0&id=51057786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51057786",
  null
  
)

export default component.exports